import PropTypes from 'prop-types'
import Styles from './ChargingSpecsAdd.module.css'
import styled from 'styled-components'
import { Colors } from 'Theme'
import { SelectPicker } from 'rsuite'
import AddIcon from '@mui/icons-material/Add'
import React, { useRef, useState, useEffect, useMemo } from 'react'
import IFSkeleton from 'Components/IFSkeleton/IFSkeleton'
import { getEnergyPriceRange } from 'Utils/Calculations'

const StyledDiv = styled.div`
  &:hover {
    color: whitesmoke;
  }
`
const ChargingSpecsAdd = ({
  data = [],
  onClick = () => {},
  onSelect = () => {},
  RenderMenuItem,
  RenderMenuItemkeys = [],
  listProps = {},
  loadMore,
  loading,
  onSearch,
  paginationOffset,
  infiniteLoader,
}) => {
  const [selectPickerPlacement, setSelectPickerPlacement] =
    useState('bottomStart')
  const options = []
  const [searchQuery, setSearchQuery] = useState('')
  const [formattedOptions, setFormattedOptions] = useState([])
  const selectPickerRef = useRef()
  const buttonRef = useRef()

  data.forEach((element) => {
    options.push({
      label: element.name,
      value: element._id,
    })
  })

  const safeData = useMemo(
    () =>
      Array.isArray(data)
        ? data.map((el) => ({
            label: el.name,
            value: el._id,
            __raw: el,
          }))
        : [],
    [data],
  )

  useEffect(() => {
    if (!infiniteLoader) return
    if (loading && searchQuery) {
      setFormattedOptions(
        Array(4).fill({ label: 'Skeleton', value: 'Skeleton' }),
      )
    } else if (loading && !searchQuery && paginationOffset == null) {
      setFormattedOptions(
        Array(4).fill({ label: 'Skeleton', value: 'Skeleton' }),
      )
    } else if (loading && searchQuery) {
      setFormattedOptions(safeData)
    } else if (!searchQuery && paginationOffset != null) {
      setFormattedOptions([
        ...safeData,
        { label: 'Skeleton', value: 'Skeleton' },
        { label: 'Skeleton', value: 'Skeleton' },
      ])
    } else {
      setFormattedOptions(safeData)
    }
  }, [infiniteLoader, loading, searchQuery, paginationOffset, safeData])

  const renderMenuItem = (label, item) => {
    if (label === 'Skeleton') {
      return <IFSkeleton variant="text" width="100%" height="1.5rem" />
    }
    const element = item.__raw
    const props = {}
    RenderMenuItemkeys.forEach((k) => (props[k] = element[k]))
    return <RenderMenuItem {...props} />
  }
  const handleSearch = (q) => {
    setSearchQuery(q)
    onSearch?.(q)
  }

  const onItemsRendered = ({ visibleStopIndex }) => {
    if (visibleStopIndex >= safeData.length - 1) {
      loadMore?.()
    }
  }

  return (
    <div className={Styles.Container}>
      <button
        className={Styles.AddButton}
        style={{ color: Colors.primary }}
        onClick={() => {
          if (
            buttonRef.current.getBoundingClientRect().y + 286 >
            window.innerHeight
          ) {
            setSelectPickerPlacement('topStart')
          } else {
            setSelectPickerPlacement('bottomStart')
          }
          selectPickerRef.current.open()
          onClick()
        }}
        ref={buttonRef}
      >
        <StyledDiv
          className={Styles.IconContainer}
          style={{ color: Colors.primary }}
        >
          <AddIcon />
        </StyledDiv>
      </button>
      <SelectPicker
        style={{
          marginTop: selectPickerPlacement === 'bottomStart' ? '-42px' : '42px',
        }}
        ref={selectPickerRef}
        placement={selectPickerPlacement}
        className={Styles.SelectPicker}
        data={infiniteLoader ? formattedOptions : options}
        onSelect={(value) => {
          onSelect(value)
        }}
        virtualized
        value={null}
        renderMenuItem={
          infiniteLoader
            ? renderMenuItem
            : (value) => {
                let element = data.find((el) => {
                  return el.name === value
                })
                let values = {}
                if (element) {
                  const { min, max } = getEnergyPriceRange(element.elements)
                  RenderMenuItemkeys.forEach((key) => {
                    if (key === 'minPrice') {
                      values[key] = min
                    } else if (key === 'maxPrice') {
                      values[key] = max
                    } else {
                      values[key] = element[key]
                    }
                  })
                }
                return (
                  <div>
                    {element && (
                      <RenderMenuItem key={`RenderMenuItem`} {...values} />
                    )}
                  </div>
                )
              }
        }
        preventOverflow={true}
        menuMaxHeight={220}
        menuStyle={{
          flexDirection:
            selectPickerPlacement === 'bottomStart'
              ? 'column'
              : 'column-reverse',

          zIndex: 10,
          maxWidth: '18.75rem',
        }}
        listProps={infiniteLoader ? { onItemsRendered } : listProps}
        onSearch={handleSearch}
        searchBy={() => true}
        disabledItemValues={['Skeleton']}
      />
    </div>
  )
}

ChargingSpecsAdd.propTypes = {
  data: PropTypes.array,
  onClick: PropTypes.func,
  onSelect: PropTypes.func,
  RenderMenuItem: PropTypes.element,
  RenderMenuItemkeys: PropTypes.array,
}

export default ChargingSpecsAdd
